import { InputField, InputSelectFieldOptions } from 'components/molecules'
import { STATUS_OPTIONS } from 'domains/product/constants'

const ProductStatusFilterField = () => (
  <>
    <InputField
      formGroupClassName={ 'mr-3' }
      type={ 'select' }
      name={ 'status' }
      label={ 'STATUS' }
      bsSize={ 'sm' }
    >
      <InputSelectFieldOptions
        options={ STATUS_OPTIONS }
      />
    </InputField>
  </>
)

export default ProductStatusFilterField
